// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingWithOverlay_overlay__3Urb2","show":"LoadingWithOverlay_show__wWzmy"};